import { axios } from '@Root/API'

export const rollback = ids => {
	return axios.post('import/rollback', ids)
}
